import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

export default class CheckboxInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    parent: PropTypes.string,
    title: PropTypes.string.isRequired,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  onCheckboxChange(event) {
    const {
      action,
      name,
      parent
    } = this.props;

    if (typeof parent !== 'undefined') {
      let val = {};
      val[name] = event.target.checked;
      action({target: {name: parent, value: val}});
    } else {
      action(event);
    }

  }

  render() {
    const {name, title, value, disabled} = this.props;
    return (
      <div className="form-group">
        <div className="supplier bb-checkbox">
          <input
            id={name}
            checked={value}
            disabled={disabled === true}
            name={name}
            onChange={::this.onCheckboxChange}
            type="checkbox" />
          <label htmlFor={name}>{title}</label>
        </div>
      </div>
    );
  }
}
